<template>
    <div v-if="mostrar" class="modal-mask" @click="$emit('fechar')">
        <div style="height: fit-content;width: 70rem; padding: 3rem; margin-bottom: 2rem; max-height: 80vh; overflow: auto;"
            class="jm" @click.stop>
            <div style="display: flex; justify-content: space-between; max-height: 100% !important;">
                <div style="width: 48%;">
                    <h3>Projetos disponíveis:</h3>
                    <select id="projetos" class="form-select" @change="$emit('associarProjeto', $event)">
                        <option hidden selected>Selecione um projeto</option>
                        <option v-for="item in projetos" :key="item.id" :value="item.id">{{ item.nome }}
                        </option>
                    </select>
                    <div v-if="programa.projeto && programa.projeto.length > 0">
                        <br>
                        <h3>Projetos associados:</h3>
                        <ul style="overflow: auto;">
                            <li v-for="(projeto, index) in programa.projeto" :key="index">
                                {{ projeto.projeto_nome }}
                                <span @click="$emit('desassociar', 'projeto', projeto.associacao_id)"
                                    style="cursor: pointer; color: red; text-align: right;"
                                    class="bi bi-dash-circle"></span>
                            </li>
                        </ul>
                        <br><br>
                    </div>
                    <div v-else>
                        <br>
                        <h4>Nenhum projeto associado.</h4>
                    </div>
                </div>
                <div style="width: 48%;">
                    <h3>Planos de ação disponíveis:</h3>
                    <select id="planosAcao" class="form-select" @change="$emit('associarPlanoAcao', $event)">
                        <option hidden selected>Selecione um plano de ação</option>
                        <option v-for="item in planosAcao" :key="item.id" :value="item.id">{{ item.nome }}
                        </option>
                    </select>
                    <div
                        v-if="programa.planoAcao && programa.planoAcao.length > 0 && programa.planoAcao[0].associacao_id !== null">
                        <br>
                        <h3>Planos de Ação associados:</h3>
                        <ul style="overflow: auto;">
                            <li v-for="(plano, index) in programa.planoAcao" :key="index">
                                {{ plano.planoAcao_nome }}
                                <span @click="$emit('desassociar', 'plano', plano.associacao_id)"
                                    class="bi bi-dash-circle"
                                    style="cursor: pointer; color: red; text-align: right;"></span>
                            </li>
                        </ul>
                    </div>
                    <div v-else>
                        <br>
                        <h4>Nenhum plano de ação associado.</h4>
                    </div>
                </div>
            </div>
            <br><br>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalProjetosAssociados",
    props: {
        mostrar: { type: Boolean, default: false },
        programa: { type: Object, default: () => ({ projeto: [], planoAcao: [] }) },
        projetos: { type: Array, default: () => [] },
        planosAcao: { type: Array, default: () => [] },
    },
    emits: ["fechar", "associarProjeto", "associarPlanoAcao", "desassociar"],
};
</script>
